module.exports = __webpack_public_path__ + "static/media/libro-ganado.d808bc66.png";